import { useEffect, useState } from "react"
import * as Yup from "yup"
import { Formik } from "formik"
import { useSnackbar } from "notistack"
import { Grid, TextField, FormHelperText } from "@material-ui/core"
import CustomModal from "src/components/Common/CustomModal"
import { StyledButton } from "src/components/Buttons/TgButton"
import { Save, SupervisedUserCircle, VerifiedUser } from "@material-ui/icons"
import { Alert } from "@material-ui/lab"
import { updateListaAprobadores } from "src/services/admin/resident"

const ListaAutorizar = ({
  idUser,
  authorized,
  tGlobal,
  tResidents,
  fullWidth,
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [authorizedNamesFormat, setAuthorizedNamesFormat] = useState([
    { name: "", lastName: "" },
    { name: "", lastName: "" },
    { name: "", lastName: "" },
    { name: "", lastName: "" },
    { name: "", lastName: "" },
  ])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  function splitName(fullName) {
    const words = fullName.trim().split(/\s+/)

    if (words.length === 2) {
      return {
        name: words[0],
        lastName: words[1],
      }
    }
    if (words.length >= 3) {
      const name = words.slice(0, 2).join(" ")
      const lastName = words.slice(2).join(" ")
      return {
        name,
        lastName,
      }
    }
    if (words.length === 1) {
      return {
        name: fullName,
        lastName: "",
      }
    }
    return {
      name: "",
      lastName: "",
    }
  }

  useEffect(() => {
    const formattedNames = [
      { name: "", lastName: "" },
      { name: "", lastName: "" },
      { name: "", lastName: "" },
      { name: "", lastName: "" },
      { name: "", lastName: "" },
    ]
    if (authorized?.length > 0) {
      authorized.forEach((name, sec) => {
        const newName = splitName(name)
        formattedNames[sec] = newName
      })
    }
    setAuthorizedNamesFormat(formattedNames)
  }, [authorized])

  return (
    <div>
      <StyledButton
        variant="outlined"
        color="primary"
        fullWidth={fullWidth !== undefined ? fullWidth : true}
        size="small"
        onClick={handleOpen}
        startIcon={<SupervisedUserCircle fontSize="small" />}
      >
        {tResidents("detail_user.view_approvers")}
      </StyledButton>
      <CustomModal
        isOpen={open}
        closeModal={handleClose}
        title={
          <>
            <SupervisedUserCircle fontSize="large" />{" "}
            {tResidents("detail_user.approvers")}
          </>
        }
      >
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={{
            listaNombre1: authorizedNamesFormat[0].name,
            listaApellido1: authorizedNamesFormat[0].lastName,
            listaNombre2: authorizedNamesFormat[1].name,
            listaApellido2: authorizedNamesFormat[1].lastName,
            listaNombre3: authorizedNamesFormat[2].name,
            listaApellido3: authorizedNamesFormat[2].lastName,
            listaNombre4: authorizedNamesFormat[3].name,
            listaApellido4: authorizedNamesFormat[3].lastName,
            listaNombre5: authorizedNamesFormat[4].name,
            listaApellido5: authorizedNamesFormat[4].lastName,
          }}
          validationSchema={Yup.object().shape({
            listaNombre1: Yup.string()
              .strict()
              .trim(tGlobal("yup_trim"))
              .max(70, `${tGlobal("yup_maxvalue")}: 70`),
            listaApellido1: Yup.string().when("listaNombre1", {
              is: nombre1 => nombre1 && nombre1.trim() !== "",
              then: Yup.string().required(tGlobal("yup_required")),
            }),
            listaNombre2: Yup.string()
              .strict()
              .trim(tGlobal("yup_trim"))
              .max(70, `${tGlobal("yup_maxvalue")}: 70`),
            listaApellido2: Yup.string().when("listaNombre2", {
              is: nombre2 => nombre2 && nombre2.trim() !== "",
              then: Yup.string().required(tGlobal("yup_required")),
            }),
            listaNombre3: Yup.string()
              .strict()
              .trim(tGlobal("yup_trim"))
              .max(70, `${tGlobal("yup_maxvalue")}: 70`),
            listaApellido3: Yup.string().when("listaNombre3", {
              is: nombre3 => nombre3 && nombre3.trim() !== "",
              then: Yup.string().required(tGlobal("yup_required")),
            }),
            listaNombre4: Yup.string()
              .strict()
              .trim(tGlobal("yup_trim"))
              .max(70, `${tGlobal("yup_maxvalue")}: 70`),
            listaApellido4: Yup.string().when("listaNombre4", {
              is: nombre4 => nombre4 && nombre4.trim() !== "",
              then: Yup.string().required(tGlobal("yup_required")),
            }),
            listaNombre5: Yup.string()
              .strict()
              .trim(tGlobal("yup_trim"))
              .max(70, `${tGlobal("yup_maxvalue")}: 70`),
            listaApellido5: Yup.string().when("listaNombre5", {
              is: nombre5 => nombre5 && nombre5.trim() !== "",
              then: Yup.string().required(tGlobal("yup_required")),
            }),
          })}
          onSubmit={async values => {
            const validList = []
            if (
              values.listaNombre1.trim() !== "" &&
              values.listaApellido1.trim() !== ""
            ) {
              validList.push(
                values.listaNombre1.concat(" ", values.listaApellido1)
              )
            }
            if (
              values.listaNombre2.trim() !== "" &&
              values.listaApellido2.trim() !== ""
            ) {
              validList.push(
                values.listaNombre2.concat(" ", values.listaApellido2)
              )
            }
            if (
              values.listaNombre3.trim() !== "" &&
              values.listaApellido3.trim() !== ""
            ) {
              validList.push(
                values.listaNombre3.concat(" ", values.listaApellido3)
              )
            }
            if (
              values.listaNombre4.trim() !== "" &&
              values.listaApellido4.trim() !== ""
            ) {
              validList.push(
                values.listaNombre4.concat(" ", values.listaApellido4)
              )
            }
            if (
              values.listaNombre5.trim() !== "" &&
              values.listaApellido5.trim() !== ""
            ) {
              validList.push(
                values.listaNombre5.concat(" ", values.listaApellido5)
              )
            }
            await updateListaAprobadores(idUser, validList)
            enqueueSnackbar(
              tResidents("detail_user.success_added_authorized"),
              {
                variant: "success",
              }
            )
            handleClose()
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form onSubmit={handleSubmit}>
              <FormHelperText>
                <Alert severity="info">
                  {tResidents("detail_user.note_authorize")}
                </Alert>
              </FormHelperText>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <VerifiedUser
                        fontSize="large"
                        style={
                          values.listaNombre1 === "" &&
                          values.listaApellido1 === ""
                            ? { opacity: 0.3 }
                            : { opacity: 1 }
                        }
                      />
                    </Grid>
                    <Grid item xs>
                      <TextField
                        error={Boolean(
                          touched.listaNombre1 && errors.listaNombre1
                        )}
                        helperText={touched.listaNombre1 && errors.listaNombre1}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.listaNombre1}
                        fullWidth
                        label={tGlobal("name")}
                        variant="outlined"
                        size="small"
                        name="listaNombre1"
                        id="listaNombre1"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    error={Boolean(
                      touched.listaApellido1 && errors.listaApellido1
                    )}
                    helperText={touched.listaApellido1 && errors.listaApellido1}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.listaApellido1}
                    fullWidth
                    label={tGlobal("lastname")}
                    variant="outlined"
                    size="small"
                    name="listaApellido1"
                    id="listaApellido1"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <VerifiedUser
                        fontSize="large"
                        style={
                          values.listaNombre2 === "" &&
                          values.listaApellido2 === ""
                            ? { opacity: 0.3 }
                            : { opacity: 1 }
                        }
                      />
                    </Grid>
                    <Grid item xs>
                      <TextField
                        error={Boolean(
                          touched.listaNombre2 && errors.listaNombre2
                        )}
                        helperText={touched.listaNombre2 && errors.listaNombre2}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.listaNombre2}
                        fullWidth
                        label={tGlobal("name")}
                        variant="outlined"
                        size="small"
                        name="listaNombre2"
                        id="listaNombre2"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    error={Boolean(
                      touched.listaApellido2 && errors.listaApellido2
                    )}
                    helperText={touched.listaApellido2 && errors.listaApellido2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.listaApellido2}
                    fullWidth
                    label={tGlobal("lastname")}
                    variant="outlined"
                    size="small"
                    name="listaApellido2"
                    id="listaApellido2"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <VerifiedUser
                        fontSize="large"
                        style={
                          values.listaNombre3 === "" &&
                          values.listaApellido3 === ""
                            ? { opacity: 0.3 }
                            : { opacity: 1 }
                        }
                      />{" "}
                    </Grid>
                    <Grid item xs>
                      <TextField
                        error={Boolean(
                          touched.listaNombre3 && errors.listaNombre3
                        )}
                        helperText={touched.listaNombre3 && errors.listaNombre3}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.listaNombre3}
                        fullWidth
                        label={tGlobal("name")}
                        variant="outlined"
                        size="small"
                        name="listaNombre3"
                        id="listaNombre3"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    error={Boolean(
                      touched.listaApellido3 && errors.listaApellido3
                    )}
                    helperText={touched.listaApellido3 && errors.listaApellido3}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.listaApellido3}
                    fullWidth
                    label={tGlobal("lastname")}
                    variant="outlined"
                    size="small"
                    name="listaApellido3"
                    id="listaApellido3"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <VerifiedUser
                        fontSize="large"
                        style={
                          values.listaNombre4 === "" &&
                          values.listaApellido4 === ""
                            ? { opacity: 0.3 }
                            : { opacity: 1 }
                        }
                      />{" "}
                    </Grid>
                    <Grid item xs>
                      <TextField
                        error={Boolean(
                          touched.listaNombre4 && errors.listaNombre4
                        )}
                        helperText={touched.listaNombre4 && errors.listaNombre4}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.listaNombre4}
                        fullWidth
                        label={tGlobal("name")}
                        variant="outlined"
                        size="small"
                        name="listaNombre4"
                        id="listaNombre4"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    error={Boolean(
                      touched.listaApellido4 && errors.listaApellido4
                    )}
                    helperText={touched.listaApellido4 && errors.listaApellido4}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.listaApellido4}
                    fullWidth
                    label={tGlobal("lastname")}
                    variant="outlined"
                    size="small"
                    name="listaApellido4"
                    id="listaApellido4"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <VerifiedUser
                        fontSize="large"
                        style={
                          values.listaNombre5 === "" &&
                          values.listaApellido5 === ""
                            ? { opacity: 0.3 }
                            : { opacity: 1 }
                        }
                      />{" "}
                    </Grid>
                    <Grid item xs>
                      <TextField
                        error={Boolean(
                          touched.listaNombre5 && errors.listaNombre5
                        )}
                        helperText={touched.listaNombre5 && errors.listaNombre5}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.listaNombre5}
                        fullWidth
                        label={tGlobal("name")}
                        variant="outlined"
                        size="small"
                        name="listaNombre5"
                        id="listaNombre5"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    error={Boolean(
                      touched.listaApellido5 && errors.listaApellido5
                    )}
                    helperText={touched.listaApellido5 && errors.listaApellido5}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.listaApellido5}
                    fullWidth
                    label={tGlobal("lastname")}
                    variant="outlined"
                    size="small"
                    name="listaApellido5"
                    id="listaApellido5"
                  />
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  style={{ marginTop: 20 }}
                >
                  <Grid item xs={4}>
                    <StyledButton
                      fullWidth
                      variant="contained"
                      color="secondary"
                      onClick={handleClose}
                    >
                      {tGlobal("cancel")}
                    </StyledButton>
                  </Grid>
                  <Grid item xs={7}>
                    <StyledButton
                      fullWidth
                      disabled={isSubmitting}
                      variant="contained"
                      color="primary"
                      type="submit"
                    >
                      <Save className="me-2" />
                      {tGlobal("save")}
                    </StyledButton>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </CustomModal>
    </div>
  )
}

export default ListaAutorizar
